import { createSlice, current } from "@reduxjs/toolkit";
import {
    getReportList, downloadReport, deleteReport,
    reportTtl, getPdf, emailPdf,
    buildReportMulti, buildReportOne
} from "./datacenterApi";

export const reportSlice = createSlice({
    name: 'reports',
    initialState: {
        reportIDs: [],
        reportData: {},
        reportDetailView: null,
    },
    reducers: {
        socketReportBuilt: (state, { payload }) => {
            console.log("New report BUILT received from server");
            const { reportIDs, reportData } = sockReportPusher(state.reportIDs, state.reportData, payload);
            state.reportIDs = reportIDs;
            state.reportData = reportData;
            return state;
        },
        setReportDetailView: (state, { payload }) => {
            if (payload !== null) {
                state.reportDetailView = payload;
            } else {
                state.reportDetailView = null;
            }
            return state;
        },
        reportSubmitted: (state, { payload }) => {
            console.log("New report request submitted to  server");
            const { reportIDs, reportData } = sockReportPusher(state.reportIDs, state.reportData, payload);
            state.reportIDs = reportIDs;
            state.reportData = reportData;
            return state;
        },
    },
    extraReducers: {
        [getReportList.fulfilled]: (state, { payload }) => {
            const { reportIDs, reportData } = reportListBuild(payload);
            state.reportIDs = reportIDs;
            state.reportData = reportData;
            //console.log("reportlist updated", reportIDs.length);
            return state;

        },
        [downloadReport.fulfilled]: (state, { payload }) => {
            //console.log("Download reducer", payload);
            state.reportData[payload.reportID].dataTable = true;
            state.reportData[payload.reportID] = {
                ...state.reportData[payload.reportID],
                ...payload.reportData
            };
            //console.log("Report Slice", state.reportData[payload.reportID]);
            return state;
        },
        [deleteReport.fulfilled]: (state, { payload }) => {
            //console.log("delete opayload", payload);
            const { reportIDs, reportData } = deleteReportData(state.reportIDs, state.reportData, payload.reportID);
            state.reportIDs = reportIDs;
            state.reportData = reportData;
            return state;
        },
        [buildReportOne.fulfilled]: (state, { payload }) => {
            console.log("Buildreport ONE response recd", payload);
            payload.forEach(p => {
                const { reportIDs, reportData } = sockReportPusher(state.reportIDs, state.reportData, p);
                state.reportIDs = reportIDs;
                state.reportData = reportData;
            })
            return state;
        },
        [buildReportMulti.fulfilled]: (state, { payload }) => {
            console.log("Buildreport MULTI response recd", payload);
            if (payload) {
                const { reportIDs, reportData } = sockReportPusher(state.reportIDs, state.reportData, payload);
                state.reportIDs = reportIDs;
                state.reportData = reportData;
            }
            return state;
        }
    },
})

export {
    getReportList, downloadReport,
    deleteReport, reportTtl, getPdf, emailPdf,
    buildReportMulti, buildReportOne
};

export const {
    socketReportBuilt, setReportDetailView, reportSubmitted
} = reportSlice.actions;

export const reportIDsSelector = state => state.reports.reportIDs;
export const trackDataSelector = state => state.reports.reportData;
export const reportDetailViewSelector = state => state.reports.reportDetailView;


function deleteReportData(list, data, reportID) {
    let reportIDs = [...list];
    let reportData = { ...data };

    reportIDs = reportIDs.filter(a => a !== reportID);
    reportData[reportID] = null;
    return { reportIDs, reportData };
}

function reportListBuild(reports) {
    let reportIDs = [];
    let reportData = {};
    //console.log("trtack reportListBuild", reports);
    if (reports.length > 0) {
        reports.forEach(report => {
            const { reportID, reportType } = report;
            if (reportType !== 'track') {
                //console.log("reportids", reportIDs, reportID);
                if (reportIDs.indexOf(reportID) === -1) {
                    reportIDs.push(reportID);
                }
                reportData = {
                    ...reportData,
                    [reportID]: {
                        ...reportData[reportID],
                        ...report,
                    },
                };
            }

        })
    }
    reportIDs = sortReportIDs(reportIDs, reportData);
    //console.log("reportlist updated", reportIDs.length);
    return { reportIDs, reportData };
}

function sockReportPusher(list, data, reportSummary) {
    let reportIDs = [...list];
    let reportData = { ...data };
    const { reportID, reportType } = reportSummary;
    if (reportType !== 'track') {
        if (reportIDs.indexOf(reportID) === -1) {
            reportIDs.push(reportID);
        }
        reportData = {
            ...reportData,
            [reportID]: {
                ...reportData[reportID],
                ...reportSummary
            },
        };
    }

    reportIDs = sortReportIDs(reportIDs, reportData);
    return { reportIDs, reportData };
}

function sortReportIDs(list, content) {
    list.sort(function (a, b) {
        const keyA = content[`${a}`].reqTime;
        const keyB = content[`${b}`].reqTime;

        return keyB - keyA;
    });
    return list;
}